import Handlebars from 'handlebars';
import i18n from 'l10n';
import Template from 'js/templates/profile.permissions.hbs';
import ServicesView from 'js/views/services.view';
import ShopsView from 'js/views/shops.view';
import {bootstrap as FBSDKLoader, settings as FBSDKSettings} from "fbSdkLoader";

import {_, Backbone} from "backboneAdapter";

require('jqueryUI');
let $ = Backbone.$;

var ManagePermissions = Backbone.View.extend({
    el: $("#manage-permissions-container"),
    domain: null, //'.page',
    template: Handlebars.compile(Template),
    fbReady: false,
    fbApi: {},
    model: {},
    initialize: function (options) {
        this.$el.append('<i id="permissions-spinner" class="icon-loading spin fg-funkyOrange header"></i>');
        FBSDKLoader(i18n.language === "el" ? "el_GR" : "en_US").then(loaded => {
            if (loaded) {
                this.fbApi = loaded;
                this.fbReady = true;
            }
            this.loadPermissions();
        });
    },
    events: {
        "change .switch input[type=checkbox]": "handleSwitch",
        "change #fb-form select": "displayExistingAssociation",
        "click #fb-form button.auth": "facebookLogin",
        "click #fb-form button.addTab": "addFbTab",
        "click #fb-form button.removeTab": "removeFbTab",
        "click .revoke": "revokeGeneralPermissions"

    },
    async facebookLogin(e) {
        e.preventDefault();
        try {
            const response = await this.fbApi.login({scope: 'public_profile,manage_pages,pages_show_list'});
            console.log("FB Login response:", response);
            if (response.status === "connected") {
                await $.postDefaultQ("/CampaignCloud/oauthClient/facebook/token", response.authResponse);
                location.hash = "#manage-permissions";
                location.reload();
            }
        } catch (exception) {
            console.error(exception);
        }
    },
    async loadPermissions() {
        let permissions = this.model = await $.ajaxDefaultQ({
            url: '/CampaignCloud/oauthClient/permissions',
            type: 'get',
            dataType: 'json',
            cache: false
        });

        const fbPerm = permissions["facebook"];
        if (fbPerm.enabled) {
            let fbProfile = await this.fbApi.api('/me', 'get', {
                access_token: fbPerm.token,
                fields: [
                    'picture',
                    'accounts',
                    'name',
                    'permissions'
                ]
            });
            if (fbProfile.error && fbProfile.error.type === "OAuthException") {
                let deauth = await $.postDefaultQ('/CampaignCloud/oauthClient/facebook/deauth');
                console.log(deauth ? "Deauth successful" : "Deauth failed");
                fbPerm.enabled = false;
                location.hash = "#manage-permissions";
                location.reload();
            }
            fbProfile.permissions.data.forEach(d => fbPerm[d.permission] = d.status === "granted");

            this.graphAssociations = await $.getDefaultQ("/CampaignCloud/oauthClient/facebook/association");

            fbPerm.picture = fbProfile.picture.data.url;
            fbPerm.name = fbProfile.name;
            if (fbPerm["manage_pages"])
                fbPerm.accounts = fbProfile.accounts.data;
        }
        // this part renders the tab
        // TODO create a model and render it appropriately
        var html = this.template(permissions);
        this.$el.html(html);
        this.shopsView = new ShopsView();
        //
        // Add the optin selector AFTER RENDERING!!!
        // then continue with the rest of the visuals
        this.servicesView = new ServicesView({
            el: "#optin-options .content",
            embedded: true,
            optin: true,
            instantWin: true,
            payPalPayment: true,
            usedFor: "external"
        });
        this.servicesView.setTemplateCollectionData();

        this.servicesView.off("selected:service").on("selected:service", event => {
            console.info("Service selected: ", event);
            this[event.method](event.model, event.originalEvent, event.extra);
        });

        this.optinAccordion = this.$("#optin-options .accordion");
        this.optinAccordion.accordion({
            action: frame => $("#optinView").hide()
        });
        await this.displayFbManagedPages();
    },
    async displayFbManagedPages() {
        let accounts = this.model["facebook"].accounts;
        if (!accounts || accounts.length === 0) return;
        var $select = $('#fb-form').find('select');
        $select.empty();
        accounts.forEach(
            d => $select.append(`<option value="${d.access_token}" data-node-id="${d.id}">${d.name}</option>`)
        );
        await this.displayExistingAssociation();
    },
    async displayExistingAssociation() {
        const $select = $('#fb-form').find('select');

        this.$("#fb-tab-name").val("");
        let accessToken = $select.val();
        let gID = $select.find(`[value="${accessToken}"]`).data("node-id");
        let existingTab = this.graphAssociations
            .find(a => a.graphNode === parseInt(gID));
        if (existingTab) {
            const optinId = existingTab.campaignId;
            const {data} = await this.fbApi.api('/me/tabs', 'get', {
                fields: [
                    'application',
                    'custom_name',
                    'name'
                ],
                access_token: accessToken
            });

            let preexistingTab = data
                .filter(
                    x => x.hasOwnProperty('application') &&
                        x.application.id === FBSDKSettings.appId
                )[0];
            if (preexistingTab) {
                console.info('A tab for this page and tellody profile already exists:', preexistingTab);
                const {custom_name, name} = preexistingTab;
                this.$("#fb-tab-name").val(custom_name ? custom_name : name);
                this.selectOptin(optinId, null, null);
                $("button.removeTab").prop("disabled", false);
            }
        } else {
            $("#optinView").empty();
            $(".selected").removeClass("selected");
            $("button.addTab").prop("disabled", true);
            $("button.removeTab").prop("disabled", true);
        }
    },
    async addFbTab(e) {
        e.preventDefault();
        const $select = $('#fb-form').find('select');
        const campaignId = this.servicesView.id;
        let customName = this.$("#fb-tab-name").val();
        let accessToken = $select.val();
        let data = await this.fbApi.api('/me/tabs', 'post', {
            access_token: accessToken,
            custom_name: customName,
            app_id: FBSDKSettings.appId,
            // custom_image_url: 'https://app.tellody.com/CampaignCloud/resources/images/logo.png'
        });
        if (data.success) {
            let newAssociation = {
                graphNode: $select.find(`[value="${accessToken}"]`).data("node-id"),
                campaignId: campaignId
            };
            let assoc = await $.ajaxDefaultQ({
                url: '/CampaignCloud/oauthClient/facebook/association',
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(newAssociation)
            });
            this.graphAssociations.push(newAssociation);
            $.Notify[assoc ? "show" : "error"](
                i18n.t("generic.addition") + " " +
                i18n.t(assoc ? "generic.=OK" : "generic.=Error")
            );
            this.displayExistingAssociation();
        }
    },
    async removeFbTab(e) {
        e.preventDefault();
        const $select = $('#fb-form').find('select');
        const accessToken = $select.val();
        const graphNode = Number($select.find(`[value="${accessToken}"]`).data("node-id"));
        //call facebook to delete the page tab
        let data = await this.fbApi.api('/me/tabs', 'delete', {
            access_token: accessToken,
            tab: 'app_' + FBSDKSettings.appId
        });

        if (data.success) {
            //remove the dead association
            let assocDeleted = await $.ajaxDefaultQ({
                url: '/CampaignCloud/oauthClient/facebook/association',
                method: 'DELETE',
                contentType: 'application/json',
                data: JSON.stringify({
                    graphNode: graphNode
                })
            });
            if (assocDeleted) {
                console.info("Association deleted successfuly");
            }
            //update state and ui. No need to check for successful deletion to do this, because if the tab
            //doesn't exist, this association will be ignored anyway. This happens in the initial rendering too.
            let gnIdx = _.findIndex(this.graphAssociations, ga => ga.graphNode === graphNode);
            this.graphAssociations.splice(gnIdx, 1);
            this.servicesView.id = -1;
            this.displayExistingAssociation();
        }
        $.Notify[data.success ? "show" : "error"](
            i18n.t("generic.deletion") + " " +
            i18n.t(data.success ? "generic.=OK" : "generic.=Error")
        );
    },
    async revokeGeneralPermissions(e) {
        e.preventDefault();
        var tgt = $(e.currentTarget);
        var resp;
        let url = tgt.data('url');
        if (url) {
            resp = await $.ajaxDefaultQ({
                url: url,
                type: 'post',
                cache: false
            });
        } else {
            resp = await this[tgt.data('cb')]();
        }
        if (resp) {
            $.Notify.show(i18n.t("revokePermissionsSuccess"));
            this.$el.find('permissions-spinner').show();
            this.loadPermissions();
        } else {
            $.Notify.error(i18n.t("revokePermissionsError"));
        }
    },
    selectOptin: function (serviceId, event, type) {
        $(".paymentSelectable").css("font-weight", 300);

        let e = this.$("#optin-options");
        e.find(".accordion .heading").addClass("collapsed");
        e.find(".accordion .content").slideUp();
        e.find(".accordion .selected").removeClass('selected');

        if (event)
            $(event.currentTarget).addClass('selected');
        else
            $(`[data-service-id=${serviceId}]`).addClass('selected');

        this.refreshOptinPreview('#optinView', '#optin-options .selected');

        this.servicesView.id = serviceId;
        $("button.addTab").prop("disabled", false);
    },
    refreshOptinPreview: function (viewElement, selectedElement) {
        var campaignSelect = $(viewElement);
        var $selected = $(selectedElement).first().parent().parent();
        if ($selected.length > 0)
            campaignSelect.html($selected.clone());
        campaignSelect.show();
    },
    async revokeFbPermissions() {
        console.log("trying to revoke fb permissions");
        try {
            let deleted = await this.fbApi
                .api('/me/permissions', 'delete', {access_token: this.model["facebook"].token});
            if (deleted.success)
                return true;
        } catch (e) {
            console.error(e);
        }
        return false;
    },
    async handleSwitch(event) {
        const $ct = $(event.currentTarget);
        const attr = $ct.data('attr');
        const chk = $ct.is(':checked');
        try {
            if (attr === "facebook.manage_pages") {
                var res;
                let fbPerm = this.model["facebook"];
                if (chk) {
                    res = await this.fbPermissionReReq('manage_pages');
                    if (res) {
                        let {data} = await this.fbApi.api('/me/accounts', 'get', {
                            access_token: fbPerm.token
                        });
                        fbPerm.accounts = data;
                        this.displayFbManagedPages();
                    }
                } else {
                    res = await this.fbPermissionRevoke('manage_pages');
                }
                if (!res)
                    $ct.prop('checked', !chk);
                else {
                    fbPerm.manage_pages = chk;
                    $("#add-fb-tab-form")[chk ? "show" : "hide"]();
                }
            }
        } catch (error) {
            console.error(error);
        }
    },
    async fbPermissionReReq(scope) {
        let rereq = await this.fbApi.login({scope: scope, auth_type: "rerequest"});
        console.log(rereq);
        return rereq.status === "connected";

    },
    async fbPermissionRevoke(scope) {
        let deleted = await this.fbApi.api(
            '/me/permissions',
            'delete', {
                access_token: this.model["facebook"].token,
                permission: scope
            }
        );
        $.Notify[deleted.success ? "show" : "error"](i18n.t("revokePermissions" + (deleted ? "Success" : "Error")));
        return deleted;
    }
});

// Returning instantiated views can be quite useful for having "state"
export default ManagePermissions;
